import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import Excerpt from "../../atoms/Excerpt";
import StoryMetaData from "../StoryMetaData";
import SponsorDetails from "../SponsorDetails";
import Caption from "../../atoms/Caption";

import { getExcerpt } from "../../utils/utils";

import "./first-story.m.css";

const FirstStory = ({ story, className = "" }) => {
  const excerpt = getExcerpt(story);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";
  const sponsor = sponsorId && !showLiveBlog;

  return (
    <div styleName="base" className={className}>
      <div styleName="container">
        <div styleName="image">
          <CardImage
            story={story}
            linkEnable={true}
            imageType="image3x2"
            aspectRatio={[3, 2]}
            className="card-with-image-zoom"
            widths={[420]}
          />
          <Caption story={story} />
        </div>

        <div styleName="data">
          <NewsHeadline Htag="h1" story={story} />
          <Excerpt excerpt={excerpt} url={story.url} />
          {!sponsor && <StoryMetaData story={story} isPublished={true} />}
        </div>
      </div>
      {sponsor && <SponsorDetails sponsorId={sponsorId} showImage={false} />}
    </div>
  );
};

FirstStory.propTypes = {
  story: object,
  className: string,
};

export default FirstStory;
